import { CardBody, CardBodyProps } from "./CardBody";

import { PropsWithChildren } from "react";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";

export type ClickableRoundedCardProps = {
  handleClick: Function;
  disabled: boolean;
  className?: string;
  iconBackgroundColour?: string;
  iconForegroundColour?: string;
  renderChildrenOnly?: boolean;
} & CardBodyProps &
  PropsWithChildren;

export const ClickableRoundedCard = ({
  handleClick,
  disabled,
  className,
  renderChildrenOnly = false,
  children,
  ...rest
}: ClickableRoundedCardProps) => {
  return (
    <button className="block w-full min-w-0" disabled={disabled} onClick={() => handleClick()}>
      <RoundedCard className={className}>
        <div className="flex flex-col h-full text-left w-full">
          {!renderChildrenOnly && <CardBody {...rest} />}
          {children}
        </div>
      </RoundedCard>
    </button>
  );
};

ClickableRoundedCard.defaultProps = { showChevron: true, disabled: false };
